import { ApolloProvider } from "@apollo/client";
import apolloClient from "@apolloConfigs/apolloClient";
// import NotificationPermissionModal from "@components/NotificationPermissionModal";
import {
  CacheControllerProvider,
  ThemeProvider as CPJProvider,
  MetaProvider,
  NotificationProvider,
  useMobile,
  UserTypeEnum,
  WaitingIcon,
} from "@cpj-ai/panel-npm-package";
import { HeroUIProvider } from "@heroui/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import MainRoutes from "@routes/MainRoutes";
import { firebaseApp } from "@utils/firebaseApp";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";

import "@styles/index.css";
import { theme } from "./themes";

function App() {
  const isMobile = useMobile();

  return (
    <CPJProvider theme={theme}>
      <HeroUIProvider locale="en-GB">
        <ApolloProvider client={apolloClient}>
          <GoogleOAuthProvider clientId={import.meta.env.VITE_PUBLIC_GOOGLE_CLIENT_ID}>
            <MetaProvider metaFileName={import.meta.env.VITE_PUBLIC_META_FILE_NAME} />
            {import.meta.env.VITE_PUBLIC_REFRESH_ON_VERSION_CHANGE && <CacheControllerProvider />}
            <NotificationProvider firebaseApp={firebaseApp} userType={UserTypeEnum.USER} />
            <RouterProvider router={MainRoutes} />
          </GoogleOAuthProvider>
          <Toaster
            toastOptions={{
              position: isMobile ? "top-center" : "bottom-center",
              duration: 5000,
              loading: {
                icon: <WaitingIcon width={20} fill="#F5A524" />,
              },
            }}
          />
        </ApolloProvider>
      </HeroUIProvider>
    </CPJProvider>
  );
}

export default App;
